// frontend/src/pages/LandingPage.jsx
import React, { useEffect, useMemo, useState } from "react";
import { FaFacebookF, FaHandshake, FaInstagram, FaMapMarkerAlt, FaSeedling } from "react-icons/fa";
import { SiGoogleplay } from "react-icons/si";
import backgroundImg from "../assets/Background.jpeg";
import sahabatKakaoImg from "../assets/Sahabatkakao.png";
import Layanan from "./Layanan";
import "./LandingPage.css";

const API = process.env.REACT_APP_API_URL || "/api";

const SYARAT_LIST = [
  "Warga negara Indonesia",
  "Tidak menjalankan usaha yang berkaitan dengan kakao di area hutan",
  "Tidak memperkerjakan anak dibawah umur (<17 tahun)",
  "Menunjukkan minat dan/atau memiliki rekam jejak yang baik pada bisnis barang dan jasa terkait kakao",
  "Mematuhi semua persyaratan perizinan dan peraturan yang berlaku",
  "Memiliki badan hukum terdaftar (CV, PT, Yayasan, atau Koperasi) atau bersedia untuk mendaftarkan badan hukum secara legal jika belum tersedia.",
  "Memiliki lahan minimal 1 ha untuk dijadikan kebun entris.",
  "Mengelola pembibitan secara profesional dan sesuai standar dengan kapasitas minimum 30.000 bibit per tahun dan memenuhi konsep multiclone",
  "Mengembangkan dan mendukung penyedia jasa pertanian di dalam klaster desa kakao",
  "Memiliki kapasitas untuk berinvestasi modal",
  "Bersedia mencatat semua transaksi bisnis secara digital",
  "Bersedia mematuhi sistem dan prosedur Pihak Kedua.",
];

const EMPTY_FORM = {
  full_name: "",
  phone: "",
  email: "",
  institusi: "",
  alamat: "",
  desa: "",
  kecamatan: "",
  kabupaten: "",
  provinsi: "",
  legal_entity: "",
  legal_entity_type: "",
  land_area_ha: "",
  nursery_capacity_per_year: "",
  business_experience: "",
  additional_notes: "",
};

export default function LandingPage() {
  const [openRegModal, setOpenRegModal] = useState(false);
  const [agreed, setAgreed] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState(EMPTY_FORM);

  useEffect(() => {
    if (window.location.hash !== "#tentang-sahabat-kakao") return;
    const frame = window.requestAnimationFrame(() => {
      document.getElementById("tentang-sahabat-kakao")?.scrollIntoView({ block: "start" });
    });
    return () => window.cancelAnimationFrame(frame);
  }, []);

  const requiredError = useMemo(() => {
    if (!agreed) return "";
    if (!form.full_name.trim()) return "Nama lengkap wajib diisi.";
    if (!form.phone.trim()) return "Nomor HP wajib diisi.";
    if (!form.institusi.trim()) return "Institusi wajib diisi.";
    if (!form.alamat.trim()) return "Alamat lengkap wajib diisi.";
    if (!form.desa.trim()) return "Desa wajib diisi.";
    if (!form.kecamatan.trim()) return "Kecamatan wajib diisi.";
    if (!form.kabupaten.trim()) return "Kabupaten wajib diisi.";
    if (!form.provinsi.trim()) return "Provinsi wajib diisi.";
    if (!form.legal_entity.trim()) return "Status badan hukum wajib dipilih.";
    if (!form.land_area_ha.toString().trim()) return "Luas lahan wajib diisi.";
    if (!form.nursery_capacity_per_year.toString().trim()) return "Kapasitas pembibitan wajib diisi.";
    return "";
  }, [agreed, form]);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const closeModal = () => {
    setOpenRegModal(false);
    setAgreed(false);
    setSaving(false);
    setForm(EMPTY_FORM);
  };

  const submitRegistration = async (e) => {
    e.preventDefault();
    if (requiredError) {
      alert(requiredError);
      return;
    }

    try {
      setSaving(true);
      const res = await fetch(`${API}/sahabat-registrations`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...form, agreed_terms: true }),
      });
      const json = await res.json().catch(() => ({}));
      if (!res.ok || !json?.success) {
        throw new Error(json?.message || `HTTP ${res.status}`);
      }
      alert(json.message || "Pendaftaran berhasil dikirim.");
      closeModal();
    } catch (err) {
      alert(`Gagal mengirim pendaftaran. ${err?.message || ""}`);
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <style>{`
        .landing-container {
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          color: #4B2E05;
          min-height: calc(100dvh - var(--sb-h, 4.625rem));
          margin-top: -0.125rem;
          background-image: linear-gradient(rgba(255, 243, 224, 0.88), rgba(255, 243, 224, 0.88)), url(${backgroundImg});
          background-size: cover;
          background-position: center center;
          background-repeat: no-repeat;
          background-attachment: fixed;
          overflow: visible;
        }

        .hero {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 24px;
          padding: 22px 24px;
          background: rgba(255, 243, 224, 0.78);
          border-radius: 16px;
          height: calc(100dvh - var(--sb-h, 4.625rem) - 28px);
          box-sizing: border-box;
          backdrop-filter: blur(1px);
          flex-direction: row;
        }

        .landing-about {
          min-height: calc(100dvh - var(--sb-h, 4.625rem));
          scroll-margin-top: var(--sb-h, 4.625rem);
          background: #fff;
          border-top: 1px solid #e5e7df;
        }

        .hero-content { max-width: 60%; }
        .hero-img { max-width: 40%; }
        .hero-img img {
          width: 100%;
          height: auto;
          border-radius: 12px;
          display: block;
          background: rgba(255,255,255,.22);
        }

        .hero-title {
          font-size: 1.8rem;
          font-weight: 600;
          color: #E67E22;
          margin: 0 0 .25rem 0;
        }

        .hero-paragraph { font-size: 1rem; line-height: 1.6; margin: 0.5rem 0; }
        .social-links { display: flex; gap: 20px; margin-top: 1rem; }
        .privacy-wrap { margin-top: 10px; }
        .privacy-link { color: #2f6b2f; font-weight: 600; text-decoration: underline; }
        .privacy-link:hover { filter: brightness(0.9); }
        .landing-actions { display: flex; gap: 12px; margin-top: 10px; margin-bottom: 6px; flex-wrap: wrap; }

        .landing-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 10px 16px;
          border-radius: 10px;
          font-weight: 700;
          font-size: 0.96rem;
          text-decoration: none;
          border: 1px solid transparent;
          transition: filter .2s ease, transform .1s ease;
          cursor: pointer;
        }
        .landing-btn:hover { filter: brightness(1.03); transform: translateY(-1px); }
        .landing-btn.primary { background: #2f6b2f; color: #fff; }
        .landing-btn.secondary { background: #fff; border-color: #2f6b2f; color: #2f6b2f; }

        .social-link {
          font-weight: 600;
          font-size: 1.05rem;
          display: inline-flex;
          align-items: center;
          gap: 8px;
          text-decoration: none;
        }
        .social-link.facebook { color: #3b5998; }
        .social-link.instagram { color: #E1306C; }
        .social-link.playstore { color: #01875f; }

        .reg-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0, 0, 0, 0.45);
          z-index: 3000;
          display: grid;
          place-items: center;
          padding: 16px;
        }

        .reg-modal {
          width: min(900px, 96vw);
          max-height: 92vh;
          overflow: auto;
          background: #fff;
          border-radius: 14px;
          border: 1px solid #e2e2e2;
          padding: 18px;
        }

        .reg-head {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          margin-bottom: 10px;
        }

        .reg-title {
          margin: 0;
          font-size: 1.4rem;
          color: #1e5c2d;
        }

        .reg-close {
          border: 1px solid #dadada;
          background: #fff;
          border-radius: 8px;
          padding: 6px 10px;
          font-weight: 700;
          cursor: pointer;
        }

        .reg-subtitle {
          margin: 0 0 8px;
          font-size: 1.02rem;
          color: #2f6b2f;
          font-weight: 700;
        }

        .req-list {
          margin: 0;
          padding-left: 18px;
          display: grid;
          gap: 7px;
          color: #3d3120;
        }

        .agree-row {
          display: flex;
          align-items: flex-start;
          gap: 8px;
          margin-top: 14px;
          padding-top: 12px;
          border-top: 1px solid #ededed;
        }

        .agree-row input { margin-top: 3px; }

        .reg-form {
          margin-top: 14px;
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 10px;
        }

        .reg-field { display: grid; gap: 4px; }
        .reg-field.full { grid-column: 1 / -1; }

        .reg-field label {
          font-size: 0.92rem;
          font-weight: 700;
          color: #2f3f2a;
        }

        .reg-field input,
        .reg-field select,
        .reg-field textarea {
          border: 1px solid #d3d3d3;
          border-radius: 8px;
          padding: 9px 10px;
          font-size: 0.95rem;
          outline: none;
        }

        .reg-field textarea { min-height: 86px; resize: vertical; }

        .reg-footer {
          margin-top: 14px;
          display: flex;
          justify-content: flex-end;
          gap: 10px;
        }

        .reg-btn {
          border: 0;
          border-radius: 8px;
          padding: 10px 14px;
          font-weight: 700;
          cursor: pointer;
        }

        .reg-btn.cancel { background: #efefef; color: #333; }
        .reg-btn.submit { background: #1f6f3f; color: #fff; }
        .reg-btn:disabled { opacity: .6; cursor: not-allowed; }

        .reg-hint {
          margin-top: 8px;
          font-size: .88rem;
          color: #7a6652;
        }

        @media (max-width: 768px) {
          .hero {
            flex-direction: column;
            align-items: stretch;
            gap: 12px;
            padding: 14px 12px 18px;
            height: auto;
            min-height: calc(100dvh - var(--sb-h, 4.625rem) - 22px);
          }
          .hero-img { order: -1; max-width: 100%; }
          .hero-content { max-width: 100%; }
          .hero-title { font-size: 1.4rem; margin-top: .25rem; }
          .hero-paragraph { font-size: .975rem; }
          .landing-actions { gap: 10px; }
          .landing-btn { width: 100%; }
          .landing-container {
            height: auto;
            min-height: calc(100dvh - var(--sb-h, 4.625rem));
            background-position: center top;
            background-attachment: scroll;
            overflow-y: auto;
            overflow-x: hidden;
          }
          .reg-form { grid-template-columns: 1fr; }
        }

        @media (max-width: 768px) and (orientation: landscape) {
          .landing-container { height: calc(100dvh - var(--sb-h, 4.625rem)); overflow: hidden; }
          .hero { height: calc(100dvh - var(--sb-h, 4.625rem) - 22px); min-height: 0; }
        }
      `}</style>

      <div className="landing-home">
        <section
          className="home-hero"
          style={{ backgroundImage: `url(${backgroundImg})` }}
          aria-labelledby="home-hero-title"
        >
          <div
            className="home-hero-art"
            style={{ backgroundImage: `url(${sahabatKakaoImg})` }}
            aria-hidden="true"
          />
          <div className="home-hero-shade" />
          <div className="home-hero-inner">
            <h1 id="home-hero-title">Sahabat Kakao</h1>
            <p className="home-hero-tagline">Solusi cerdas andalan petani</p>
            <p className="home-hero-copy">
              Menghubungkan petani dengan pengetahuan budidaya, bahan tanam unggul,
              dan layanan pertanian untuk kebun kakao yang produktif dan berkelanjutan.
            </p>

            <div className="home-hero-actions">
              <a href="https://academycocoamars.my.canva.site/" className="home-button home-button-primary">
                Informasi Training
              </a>
              <button
                type="button"
                className="home-button home-button-secondary"
                onClick={() => setOpenRegModal(true)}
              >
                Daftar Menjadi Sahabat Kakao
              </button>
            </div>

            <div className="home-hero-footer">
              <div className="home-socials" aria-label="Media sosial Sahabat Kakao">
                <a
                  className="home-social-facebook"
                  href="https://web.facebook.com/profile.php?id=61575543279361"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook Sahabat Kakao"
                  title="Facebook"
                >
                  <FaFacebookF />
                </a>
                <a
                  className="home-social-instagram"
                  href="https://www.instagram.com/sahabatkakao"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram Sahabat Kakao"
                  title="Instagram"
                >
                  <FaInstagram />
                </a>
                <a
                  className="home-social-play"
                  href="https://play.google.com/store/search?q=Sahabat%20Kakao&c=apps&hl=id"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Sahabat Kakao di Google Play"
                  title="Google Play"
                >
                  <span className="home-play-mark" aria-hidden="true">
                    <SiGoogleplay className="home-play-blue" />
                    <SiGoogleplay className="home-play-green" />
                    <SiGoogleplay className="home-play-yellow" />
                    <SiGoogleplay className="home-play-red" />
                  </span>
                </a>
              </div>
              <a href="/syarat-ketentuan" className="home-privacy-link">
                Kebijakan Privasi
              </a>
            </div>
          </div>
        </section>

        <section id="tentang-sahabat-kakao" className="home-intro" aria-labelledby="home-intro-title">
          <div className="home-intro-inner">
            <div className="home-intro-heading">
              <p>Tentang Sahabat Kakao</p>
              <h2 id="home-intro-title">Tingkatkan Produktivitas Kakao berbasis teknologi</h2>
            </div>
            <div className="home-intro-copy">
              <p>
                Sahabat Kakao adalah platform pembelajaran dan jaringan layanan yang mendukung
                petani kakao untuk berkembang secara mandiri, terhubung lebih luas, dan
                meningkatkan produktivitas kebun secara berkelanjutan.
              </p>
              <p>
                Teknologi dan pengalaman lokal dipertemukan agar pengetahuan, sarana produksi,
                dan layanan kebun semakin mudah dijangkau oleh komunitas kakao di berbagai daerah.
              </p>
            </div>
          </div>

          <div className="home-pillars">
            <article>
              <FaSeedling aria-hidden="true" />
              <div>
                <h3>Budidaya Lebih Baik</h3>
                <p>Pengetahuan praktis untuk kebun yang sehat dan produktif.</p>
              </div>
            </article>
            <article>
              <FaHandshake aria-hidden="true" />
              <div>
                <h3>Jaringan Layanan</h3>
                <p>Akses ke penyedia jasa, bahan tanam, dan kebutuhan kebun.</p>
              </div>
            </article>
            <article>
              <FaMapMarkerAlt aria-hidden="true" />
              <div>
                <h3>Dekat dengan Petani</h3>
                <p>Kolaborasi yang tumbuh dari kebutuhan komunitas setempat.</p>
              </div>
            </article>
          </div>
        </section>
      </div>

      <section className="home-services-band" aria-label="Layanan dan testimoni Sahabat Kakao">
        <Layanan />
      </section>

      {openRegModal && (
        <div className="reg-overlay" role="dialog" aria-modal="true">
          <div className="reg-modal">
            <div className="reg-head">
              <h3 className="reg-title">Pendaftaran Sahabat Kakao</h3>
              <button type="button" className="reg-close" onClick={closeModal}>
                X
              </button>
            </div>

            <p className="reg-subtitle">Syarat dan Kriteria Sahabat Kakao</p>
            <ol className="req-list">
              {SYARAT_LIST.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ol>

            <div className="agree-row">
              <input
                id="agree-terms"
                type="checkbox"
                checked={agreed}
                onChange={(e) => setAgreed(e.target.checked)}
              />
              <label htmlFor="agree-terms">
                Saya menyatakan setuju dengan seluruh syarat dan kriteria di atas.
              </label>
            </div>

            {agreed && (
              <form className="reg-form" onSubmit={submitRegistration}>
                <div className="reg-field">
                  <label>Nama Lengkap *</label>
                  <input name="full_name" value={form.full_name} onChange={handleInput} />
                </div>

                <div className="reg-field">
                  <label>Nomor HP / WhatsApp *</label>
                  <input name="phone" value={form.phone} onChange={handleInput} />
                </div>

                <div className="reg-field">
                  <label>Email (Opsional)</label>
                  <input name="email" value={form.email} onChange={handleInput} />
                </div>

                <div className="reg-field">
                  <label>Institusi *</label>
                  <input name="institusi" value={form.institusi} onChange={handleInput} />
                </div>

                <div className="reg-field">
                  <label>Status Badan Hukum *</label>
                  <select name="legal_entity" value={form.legal_entity} onChange={handleInput}>
                    <option value="">Pilih status</option>
                    <option value="sudah-terdaftar">Sudah terdaftar</option>
                    <option value="bersedia-daftar">Belum ada, bersedia mendaftar legal</option>
                  </select>
                </div>

                <div className="reg-field">
                  <label>Jenis Badan Hukum (Opsional)</label>
                  <select name="legal_entity_type" value={form.legal_entity_type} onChange={handleInput}>
                    <option value="">Pilih</option>
                    <option value="CV">CV</option>
                    <option value="PT">PT</option>
                    <option value="Yayasan">Yayasan</option>
                    <option value="Koperasi">Koperasi</option>
                  </select>
                </div>

                <div className="reg-field">
                  <label>Luas Lahan (ha) *</label>
                  <input type="number" min="0" step="0.01" name="land_area_ha" value={form.land_area_ha} onChange={handleInput} />
                </div>

                <div className="reg-field">
                  <label>Kapasitas Pembibitan/Tahun *</label>
                  <input type="number" min="0" name="nursery_capacity_per_year" value={form.nursery_capacity_per_year} onChange={handleInput} />
                </div>

                <div className="reg-field full">
                  <label>Alamat Lengkap *</label>
                  <input name="alamat" value={form.alamat} onChange={handleInput} />
                </div>

                <div className="reg-field">
                  <label>Desa *</label>
                  <input name="desa" value={form.desa} onChange={handleInput} />
                </div>

                <div className="reg-field">
                  <label>Kecamatan *</label>
                  <input name="kecamatan" value={form.kecamatan} onChange={handleInput} />
                </div>

                <div className="reg-field">
                  <label>Kabupaten *</label>
                  <input name="kabupaten" value={form.kabupaten} onChange={handleInput} />
                </div>

                <div className="reg-field">
                  <label>Provinsi *</label>
                  <input name="provinsi" value={form.provinsi} onChange={handleInput} />
                </div>

                <div className="reg-field full">
                  <label>Minat/Rekam Jejak Bisnis Kakao (Opsional)</label>
                  <textarea name="business_experience" value={form.business_experience} onChange={handleInput} />
                </div>

                <div className="reg-field full">
                  <label>Catatan Tambahan (Opsional)</label>
                  <textarea name="additional_notes" value={form.additional_notes} onChange={handleInput} />
                </div>

                <div className="reg-field full">
                  <div className="reg-footer">
                    <button type="button" className="reg-btn cancel" onClick={closeModal}>
                      Batal
                    </button>
                    <button type="submit" className="reg-btn submit" disabled={saving || !!requiredError}>
                      {saving ? "Mengirim..." : "Kirim Pendaftaran"}
                    </button>
                  </div>
                  {requiredError ? <div className="reg-hint">{requiredError}</div> : null}
                </div>
              </form>
            )}
          </div>
        </div>
      )}
    </>
  );
}





